/**
 * Tasks store module. Only add Task related functions and data here
 *
 * @module store/tasks/state
 */

export const state = () => ({
  totalTasksCount: 0,
  incompleteTasksCount: 0,
  openTasksCount: 0,
  tasks: []
});
